import request from '@/common/request'

class CSTService {
  getAll() {
    return request.get('/csts')
  }

  getAllPisCofins() {
    return request.get('/csts/piscofins')
  }

  create(data) {
    return request.post('/csts', data)
  }

  update(id, data) {
    return request.patch(`/csts/${id}`, data)
  }

  deleteById(id) {
    return request.delete(`/csts/${id}`)
  }
}

export default new CSTService()
